let isReload = true;


// const pickupDelay = parseInt(document.getElementById('possible_recup_day')?.textContent || 0, 10);
// const deliveryDelay = parseInt(document.getElementById('possible_livraison_day')?.textContent || 0, 10);
const blockdisplayestimat = document.getElementById('date_estimated');
const moyen_livraison = document.getElementById('moyen_livraison');
const heureSelect = document.getElementById('heure_retrait');
const heure_retrait_input = document.getElementById('heure_retrait_input');

const evenement_name_attribute = document.getElementById('evenement_name_attribute');

var hiddenInput = document.getElementById("delivery_date_input");
const date_retrait_input = document.getElementById('date_retrait_input');
const date_estimation_livraison_order = document.getElementById('date_estimation_livraison_order');
const btn_to_proced = document.getElementById('checkout');
const delivery_footer_retrait = document.getElementById('delivery_footer');
const adresse_tatapaulette = document.getElementById('adresse_tatapaulette');
const information_header = document.querySelector('.info-head');

const alert_body_text_delivery = document.querySelector('.alert-body-text-delivery');
const deliveryContentAll = document.querySelector('.delivery_chose_content_all');

function updateCartNote() {
  const recap = [];
  const mode = document.getElementById('moyen_livraison')?.value;
  const date = document.getElementById('date_retrait_input')?.value;
  const heure = document.getElementById('heure_retrait_input')?.value;
  if (mode) recap.push(mode);
  if (date) recap.push('Date : ' + date);
  if (heure) recap.push('Heure : ' + heure);
  const note = document.getElementById('cart-note');
  if (note) note.value = recap.join(' | ');
}


const debut_vacance = document.getElementById('debut_vacance');
const fin_vacance = document.getElementById('fin_vacance');

var today = new Date();

let calendar = null;

// Date (ou fenêtre de livraison) choisie dans le calendrier : { debut: 'YYYY-MM-DD', fin: 'YYYY-MM-DD' }
let selectionCalendrier = null;

let isPhantomCartAction = false;

window.currentDeliveryMode = 'pickup';


document.addEventListener("DOMContentLoaded", function() {
    
    // addProduitFantone(57196670321027,57196671959427)

    // On intercepte toutes les requêtes fetch (Shopify utilise fetch pour mettre à jour le panier)
    const originalFetch = window.fetch;
    window.fetch = function(...args) {

        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

        // Requêtes marquées comme "ne pas réinitialiser le calendrier"
        // (ex : enregistrement du mode de livraison dans les attributs du panier)
        const reqHeaders = args[1]?.headers || {};
        const skipReset = reqHeaders['X-Skip-Cart-Reset'] === '1';

        const isCartAction = !isPhantomCartAction && !skipReset &&
            (url.includes('/cart/change') || url.includes('/cart/update'));

        if (isCartAction) {
            showLoader();
        }

        return originalFetch.apply(this, args).then(response => {
          
            if (isCartAction) {

                setTimeout(async () => {

                    try {

                        const cartResponse = await fetch('/cart.js');
                        const cart = await cartResponse.json();
                      
                        const variantPickup = 57196670321027;
                        const variantDelivery = 57196671959427;
                        
                        const onlyPickupVariant = 
                            cart.items.length === 1 && 
                            cart.items[0].variant_id === variantPickup;
                        
                        const onlyDeliveryVariant = 
                            cart.items.length === 1 && 
                            cart.items[0].variant_id === variantDelivery;

                        if (onlyPickupVariant) {
                            showLoader();
                            await fetch('/cart/clear.js', {
                                method: 'POST',
                                headers: {'Content-Type': 'application/json'}
                            });
                            location.reload();
                        } 
                        else if (onlyDeliveryVariant) {
                            showLoader();
                            await fetch('/cart/clear.js', {
                                method: 'POST',
                                headers: {'Content-Type': 'application/json'}
                            });
                            location.reload();
                        }
                    
                        resetCalendar();
                        if (typeof updateCartAdditionalTotal === "function") updateCartAdditionalTotal();
                        
                    } catch (error) {
                        console.error('Erreur vérification panier:', error);
                    }
                }, 500);

                setTimeout(() => {
                    hideLoader();
                }, 2000);

            }
            
            return response;

        });

    };

});


    function showLoader() {
        const loader = document.querySelector('.loader_panier');
        
        if (loader) {
            loader.style.display = 'block';
        }

        if (deliveryContentAll) {
            deliveryContentAll.style.opacity = '0.5';
            deliveryContentAll.style.pointerEvents = 'none';
            deliveryContentAll.style.transition = 'opacity 0.3s ease';
        }

    }

    function hideLoader() {
        const loader = document.querySelector('.loader_panier');
        if (loader) {
            loader.style.display = 'none';
        }

        if (deliveryContentAll) {
            deliveryContentAll.style.opacity = '1';
            deliveryContentAll.style.pointerEvents = 'auto';
        }

    }


    function createCalendar() {
        const calendarEl = document.getElementById('calendar_delivery');
        if (!calendarEl || typeof FullCalendar === 'undefined') return;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        calendar = new FullCalendar.Calendar(calendarEl, {
            initialView: "dayGridMonth",
            initialDate: today,
            locale: "fr",
            selectable: false,
            headerToolbar: {
                left: "prev",
                center: "title",
                right: "next"
            },

            dateClick(info) {
                if (
                    info.dayEl.classList.contains('fc-day-disabled-custom') ||
                    info.dayEl.classList.contains('fc-day-past')
                ) {
                    return;
                }
                choisirDate(info.dateStr);
            },

            dayCellDidMount(info) {
                updateCellAppearance(info.el, info.date);
            },

            datesSet() {
                updateCalendarAppearance();
            }
        });

        calendar.render();
        allerPremiereDateEvenement();
        majLegendeEvenement();
    }



    function parseFrenchDate(dateStr) {
        if (!dateStr) return null;
        const [jour, mois, annee] = dateStr.split('-').map(Number);
        return new Date(annee, mois - 1, jour);
    }




    function formatDateFR(isoDate) {
        const [year, month, day] = isoDate.split('-');
        return `${day}-${month}-${year}`;
    }


    function resetCalendar() {

        // On garde le mode réellement sélectionné au lieu de forcer "retrait"
        const radioMode = document.querySelector('input[name="delivery_option"]:checked');
        if (radioMode) {
            window.currentDeliveryMode = radioMode.value === 'delivery_europe' ? 'delivery' : 'pickup';
        }

        // On repart sans événement sélectionné
        selectionCalendrier = null;
        cocherRadioDate(null);
        majLegendeEvenement();

        if (!calendar) return;

        if (date_retrait_input) date_retrait_input.value = '';
        if (hiddenInput) hiddenInput.value = '';
        if (date_estimation_livraison_order) date_estimation_livraison_order.value = '';
        if (evenement_name_attribute) evenement_name_attribute.value = '';

        calendar.destroy();
        calendar = null;

        setTimeout(() => {
            createCalendar();
            checkdatavalide();
        }, 50);

    }


    async function addProduitFantone(variantToAdd, variantToRemove) {

        isPhantomCartAction = true;
        
        try {

            const initialCartResponse = await fetch('/cart.js');
            const initialCart = await initialCartResponse.json();

            const variantPickup = 57196670321027;
            const variantDelivery = 57196671959427;

            const hasOnlyPhantomBefore = 
                initialCart.items.length === 1 && 
                (initialCart.items[0].variant_id === variantPickup || 
                initialCart.items[0].variant_id === variantDelivery);

            if (hasOnlyPhantomBefore) {
                return; // On ne fait rien
            }

            // 1. Supprimer l'ancien produit fantôme
            await resetProduitFantone(variantToRemove);
            
            // 2. Vérifier le panier
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
            
            // 3. Vérifier si le nouveau produit est déjà présent
            const alreadyInCart = cart.items.some(item => item.variant_id === variantToAdd);
            
            if (!alreadyInCart) {
                // 4. Ajouter le nouveau produit fantôme
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({
                        id: variantToAdd,
                        quantity: 1
                    })
                });
            } else {
                console.log('Produit fantôme déjà présent');
            }
        } catch (error) {
            console.error('Erreur produit fantôme:', error);
        } finally {
            // Réactiver les reset après un délai plus court
            setTimeout(() => {
                isPhantomCartAction = false;
            }, 1500); // Réduit à 1.5 secondes
        }
    }

    async function resetProduitFantone(variantId) {
        try {
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
            
            const item = cart.items.find(i => i.variant_id === variantId);
            if (!item) return;
     
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    id: item.key,
                    quantity: 0
                })
            });

            if (!response.ok) {
                if (response.status === 400) {
                    return;
                }
                throw new Error(`HTTP ${response.status}`);
            }
            
        } catch (error) {
            console.error('Erreur suppression:', error);
        }
    }


    // ===== Règles de dates =====
    // Les premières dates possibles sont calculées côté Liquid (heure de la boutique) :
    // jours ouvrés mardi -> samedi, commande après 8h vue le lendemain,
    // expédition mardi -> vendredi, livraison = expédition + délai.
    function getMinDate() {
        const id = window.currentDeliveryMode === 'delivery'
            ? 'possible_livraison_date'
            : 'possible_recup_date';
        const iso = (document.getElementById(id)?.textContent || '').trim();
        if (iso) {
            const d = new Date(iso + 'T00:00:00');
            if (!isNaN(d)) return d;
        }
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        return d;
    }

    function isInVacances(date) {
        if (!debut_vacance || !fin_vacance || !debut_vacance.textContent || !fin_vacance.textContent) return false;
        const debut = parseFrenchDate(debut_vacance.textContent.trim());
        const fin = parseFrenchDate(fin_vacance.textContent.trim());
        if (!debut || !fin || isNaN(debut) || isNaN(fin)) return false;
        debut.setHours(0, 0, 0, 0);
        fin.setHours(0, 0, 0, 0);
        return date >= debut && date <= fin;
    }

    function isDayDisabled(dateInput) {
        const d = new Date(dateInput);
        d.setHours(0, 0, 0, 0);
        const day = d.getDay(); // 0 = dimanche, 1 = lundi

        // Dates d'un événement du panier (déjà filtrées côté Liquid) : toujours cliquables
        if (getEvenementPourDate(toISO(d))) return false;

        // Produit lié à un événement dans le panier : livrable / retirable uniquement pendant l'événement
        if (getEvenements().length) return true;

        if (d < getMinDate()) return true;

        if (window.currentDeliveryMode === 'delivery') {
            if (day === 0) return true;                 // pas de livraison le dimanche
        } else {
            if (day === 0 || day === 1) return true;    // boutique fermée dimanche et lundi
            if (isInVacances(d)) return true;           // pas de retrait pendant les vacances
        }

        return false;
    }


    // ===== Événements =====
    function toISO(date) {
        const d = new Date(date);
        return d.getFullYear() + '-'
            + String(d.getMonth() + 1).padStart(2, '0') + '-'
            + String(d.getDate()).padStart(2, '0');
    }

    function memeNom(a, b) {
        return (a || '').trim() === (b || '').trim();
    }

    function getEvenements() {
        const el = document.getElementById('evenements_data');
        if (!el) return [];
        try {
            return JSON.parse(el.textContent) || [];
        } catch (e) {
            return [];
        }
    }

    function findEvenement(nom) {
        if (!nom) return null;
        return getEvenements().find(e => memeNom(e.nom, nom)) || null;
    }

    function getEvenementSelectionne() {
        const r = document.querySelector('input[name="delivery_option_radio"][value="evenement_"]:checked');
        return r ? r.dataset.name : null;
    }

    // Plages ({debut, fin, valeur}) d'un événement pour le mode courant
    function getPlagesEvenement(evt) {
        if (!evt) return [];
        return (window.currentDeliveryMode === 'delivery' ? evt.livraison : evt.retrait) || [];
    }

    // Jours ("YYYY-MM-DD") couverts par les plages d'un événement pour le mode courant
    // En retrait, seuls les jours encore possibles (préparation, vacances) sont gardés :
    // le client choisit un jour précis dans la plage. En livraison, la fenêtre entière.
    function getJoursEvenement(evt) {
        const enLivraison = window.currentDeliveryMode === 'delivery';
        const min = getMinDate();
        const jours = [];
        getPlagesEvenement(evt).forEach(f => {
            let d = new Date(f.debut + 'T00:00:00');
            const fin = new Date(f.fin + 'T00:00:00');
            while (d <= fin) {
                const ok = d >= min && (enLivraison
                    ? d.getDay() !== 0          // livraison : jamais le dimanche
                    : !isInVacances(d));        // retrait : pas pendant les vacances
                if (ok) jours.push(toISO(d));
                d = addDays(d, 1);
            }
        });
        return [...new Set(jours)].sort();
    }

    // Événement contenant cette date (priorité à celui sélectionné)
    function getEvenementPourDate(iso) {
        const evts = getEvenements();
        const sel = evts.find(e => memeNom(e.nom, getEvenementSelectionne()));
        if (sel && getJoursEvenement(sel).includes(iso)) return sel;
        return evts.find(e => getJoursEvenement(e).includes(iso)) || null;
    }

    // Plage de l'événement (retrait ou livraison selon le mode) qui contient la date
    function getPlagePourDate(evt, iso) {
        return getPlagesEvenement(evt).find(f => iso >= f.debut && iso <= f.fin) || null;
    }

    // Coche le radio de l'événement (ou "date spécifique" si nom = null) sans déclencher de reset
    function cocherRadioDate(nom) {
        document.querySelectorAll('input[name="delivery_option_radio"]').forEach(r => {
            r.checked = nom
                ? (r.value === 'evenement_' && memeNom(r.dataset.name, nom))
                : r.value === 'date_specifique';
        });
    }

    function appliquerEvenement(nom) {
        if (evenement_name_attribute) {
            evenement_name_attribute.value = nom ? nom.trim() : '';
            evenement_name_attribute.required = !!nom;
        }
        majBlocHeure();
        majLegendeEvenement();
        updateCalendarAppearance();
    }

    // Choix de l'heure : obligatoire en retrait (événement ou non), jamais en livraison
    function majBlocHeure() {
        const bloc = document.querySelector('.form-chose-heure-retrait');
        const sansHeure = window.currentDeliveryMode === 'delivery'
            || getSelectedDeliveryOption() === 'des_possible';

        if (bloc) bloc.classList.toggle('d-none', sansHeure);
        if (!sansHeure && heure_retrait_input) heure_retrait_input.required = true;
    }

    // Texte sous le calendrier : "Mardi 10 Mai - Mercredi 11 Mai"
    function majLegendeEvenement() {
        const legende = document.getElementById('calendrier_evenement_legende');
        if (!legende) return;

        const fmt = iso => new Date(iso + 'T00:00:00')
            .toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })
            .split(' ')
            .map(m => m.charAt(0).toUpperCase() + m.slice(1))
            .join(' ');

        // Regroupe les jours possibles consécutifs en plages
        const textePlages = evt => {
            const plages = [];
            getJoursEvenement(evt).forEach(iso => {
                const derniere = plages[plages.length - 1];
                if (derniere && toISO(addDays(new Date(derniere[1] + 'T00:00:00'), 1)) === iso) {
                    derniere[1] = iso;
                } else {
                    plages.push([iso, iso]);
                }
            });
            return plages.map(([a, b]) => a === b ? fmt(a) : fmt(a) + ' - ' + fmt(b)).join(' · ');
        };

        const evt = findEvenement(getEvenementSelectionne());

        // Événement sélectionné : ses plages
        if (evt) {
            legende.textContent = textePlages(evt) || ('Aucune date disponible pour ' + evt.nom.trim());
            return;
        }

        // Produits liés à des événements mais aucun sélectionné : on rappelle les dates possibles
        const evts = getEvenements();
        if (!evts.length) {
            legende.textContent = '';
            return;
        }
        const lignes = evts
            .filter(e => getJoursEvenement(e).length)
            .map(e => e.nom.trim() + ' : ' + textePlages(e));
        legende.textContent = lignes.length
            ? 'Dates disponibles — ' + lignes.join(' | ')
            : (window.currentDeliveryMode === 'delivery'
                ? 'Aucune date de livraison disponible pour ces produits'
                : 'Aucune date de retrait disponible pour ces produits');
    }

    // Ouvre le calendrier sur le mois de la première plage d'événement disponible
    function allerPremiereDateEvenement() {
        if (!calendar) return;
        const debuts = getEvenements()
            .flatMap(e => getJoursEvenement(e))
            .sort();
        if (debuts.length) calendar.gotoDate(debuts[0]);
    }

    // Sélection d'un événement via son bouton radio
    function selectionnerEvenement(nom) {
        selectionCalendrier = null;
        if (date_retrait_input) date_retrait_input.value = '';
        if (date_estimation_livraison_order) date_estimation_livraison_order.value = '';
        if (blockdisplayestimat) blockdisplayestimat.textContent = '-- sélectionnez une date --';
        appliquerEvenement(nom);

        const jours = getJoursEvenement(findEvenement(nom));
        if (calendar && jours.length) calendar.gotoDate(jours[0]);

        checkdatavalide();              // le client doit cliquer son jour dans la plage
    }

    // Clic sur une date du calendrier (événement ou non)
    function choisirDate(iso) {
        const evt = getEvenementPourDate(iso);
        const nouveauNom = evt ? evt.nom : null;

        // Date hors événement -> on désélectionne l'événement ; date d'un événement -> on le sélectionne
        if (!memeNom(getEvenementSelectionne(), nouveauNom)) {
            cocherRadioDate(nouveauNom);
            appliquerEvenement(nouveauNom);
        }

        // Événement ou non : le client choisit un jour précis
        selectionCalendrier = { debut: iso, fin: iso };
        date_retrait_input.value = formatDateFR(iso);

        updateCalendarAppearance();
        checkdatavalide();
        showDateestimation();
        filterHeuresPassees(formatDateFR(iso));
    }

    // Apparence d'une cellule : désactivée, plage d'événement, date choisie
    function updateCellAppearance(cellElement, cellDate) {
        const iso = toISO(cellDate);
        cellElement.classList.toggle('fc-day-disabled-custom', isDayDisabled(cellDate));

        // Plage de l'événement sélectionné (en "pilule")
        const joursSel = getJoursEvenement(findEvenement(getEvenementSelectionne()));
        const dansSel = joursSel.includes(iso);
        const jour = cellDate.getDay();
        cellElement.classList.toggle('fc-day-evenement', dansSel);
        cellElement.classList.toggle('fc-evenement-debut',
            dansSel && (jour === 1 || !joursSel.includes(toISO(addDays(cellDate, -1)))));
        cellElement.classList.toggle('fc-evenement-fin',
            dansSel && (jour === 0 || !joursSel.includes(toISO(addDays(cellDate, 1)))));

        // Jours des autres événements du panier (petit point)
        const dansAutre = !dansSel && getEvenements().some(e => getJoursEvenement(e).includes(iso));
        cellElement.classList.toggle('fc-day-evenement-autre', dansAutre);

        // Date / fenêtre choisie
        const val = date_retrait_input ? date_retrait_input.value : '';
        const selValide = selectionCalendrier && val && val !== 'Dès que possible';
        const estChoisi = !!selValide && iso >= selectionCalendrier.debut && iso <= selectionCalendrier.fin;
        const estFenetre = estChoisi && selectionCalendrier.debut !== selectionCalendrier.fin;
        cellElement.classList.toggle('active-date', estChoisi && !estFenetre);
        cellElement.classList.toggle('fc-fenetre-choisie', estFenetre);
    }
    

    // Fonction pour mettre à jour tout le calendrier
    function updateCalendarAppearance() {
        // Pour chaque cellule du calendrier
        document.querySelectorAll('.fc-daygrid-day').forEach(cell => {
            const dateAttr = cell.getAttribute('data-date');
            if (dateAttr) {
                const cellDate = new Date(dateAttr + 'T00:00:00');
                updateCellAppearance(cell, cellDate);
            }
        });
    }


    function toStartOfDay(date) {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    function formatDateRangeFR(rangeStr) {
        const [startStr, endStr] = rangeStr.split(' - ');
        const options = { day: 'numeric', month: 'long', year: 'numeric' };

        function parseFR(dateStr) {
            const [day, month, year] = dateStr.split('-');
            return new Date(year, month - 1, day);
        }

        const startDate = parseFR(startStr);
        const endDate = parseFR(endStr);

        return `${startDate.toLocaleDateString('fr-FR', options)} - ${endDate.toLocaleDateString('fr-FR', options)}`;
    }


    function addDays(date, days) {
        const d = new Date(date);
        d.setDate(d.getDate() + days);
        return d;
    }


    function checkdatavalide() {

        if(checkValidateDate()) {
            delivery_footer_retrait.classList.add('active');
            // btn_to_proced.disabled = false;

            btn_to_proced.classList.remove('not-passed');

        } else {
            delivery_footer_retrait.classList.remove('active');
            if (!btn_to_proced.classList.contains('not-passed')) {
                btn_to_proced.classList.add('not-passed');
            }

        }

    }


     function checkValidateDate() {
        const selectedDeliveryOption = getSelectedDeliveryOption();
        const isDesQuePossible = selectedDeliveryOption === 'des_possible';

        if (
            !moyen_livraison.value ||
            (!date_retrait_input.value && !isDesQuePossible)
        ) {
            return false;
        }

        // Un jour doit être choisi dans le calendrier : cocher l'événement ne suffit pas
        if (!isDesQuePossible && !selectionCalendrier) {
            return false;
        }

        if (moyen_livraison.value === 'Livraison en europe') {
            // Pour livraison, pas d'heure requise
        } else {
            // Pour retrait, heure requise SAUF si "Dès que possible"
            if (!heure_retrait_input.value && !isDesQuePossible) {
                return false;
            }
        }
  
        return true;
    }


    function showDateestimation() {
        setTimeout(() => {
            let selectedHour = heure_retrait_input.value;
            let selectedDate = date_retrait_input.value;
            const selectedValueRadio = getSelectedDeliveryOption();
            
            if (!selectedDate || selectedDate.trim() === '') {
                console.error('Aucune date sélectionnée');
                return;
            }

            if (selectedDate === 'Dès que possible') {
                const est_livraison = moyen_livraison.value == 'Livraison en europe';
                const est_top = document.querySelector('.estimated_complete_top');
                if (est_top) {
                    est_top.textContent = est_livraison ? 'LIVRAISON ESTIMEE : ' : 'DATE DE RETRAIT ';
                }
                if (blockdisplayestimat) {
                    blockdisplayestimat.textContent = selectedDate;
                }
                updateCartNote();
                return;
            }
            
            const dateParts = selectedDate.split('-');
            
            if(selectedValueRadio != 'evenement_') {
                if (dateParts.length !== 3) {
                    console.error('Format de date invalide:', selectedDate);
                    return;
                }
            }
            
            const selectedDateformated = new Date(
                parseInt(dateParts[2], 10),
                parseInt(dateParts[1], 10) - 1, 
                parseInt(dateParts[0], 10) 
            );

            if (isNaN(selectedDateformated.getTime())) {
                console.error('Date invalide après parsing:', selectedDate);
                return;
            }
                        
            const dateMaxestimated = new Date(selectedDateformated);
            dateMaxestimated.setDate(dateMaxestimated.getDate() + 1);

            const dayOfWeek = dateMaxestimated.getDay();

            if (dayOfWeek === 0) { 
                dateMaxestimated.setDate(dateMaxestimated.getDate() + 1);
            }


            const moyen_livraison_choix = moyen_livraison.value;
            const estimated_complete_top = document.querySelector('.estimated_complete_top');
            
            const formattedDate = selectedDateformated.toLocaleDateString('fr-FR', {
                weekday: 'long',
                day: 'numeric',
                month: 'long'
            });

            const formattedDateEstimated = dateMaxestimated.toLocaleDateString('fr-FR', {
                weekday: 'long',
                day: 'numeric',
                month: 'long'
            });
            let displayText = formattedDate;
            
            
            if(moyen_livraison_choix == 'Livraison en europe') {
                estimated_complete_top.textContent = 'LIVRAISON ESTIMEE ENTRE : '
                // Même affichage avec ou sans événement : "entre le jour choisi et le lendemain"
                if (formattedDateEstimated) {
                    displayText += ' - ' + formattedDateEstimated;
                }
                if(date_estimation_livraison_order) {
                    // Les deux dates au même format jj-mm-aaaa, en heure locale
                    // (toISOString décalait d'un jour à cause du fuseau horaire)
                    date_estimation_livraison_order.value = selectedDate + ' - ' + formatDateFR(toISO(dateMaxestimated));
                }
            } else {
                estimated_complete_top.textContent = 'DATE DE RETRAIT '
                if (selectedHour) {
                    displayText += ' à partir de ' + selectedHour;
                }
            }
            
            if (blockdisplayestimat) {        
                blockdisplayestimat.textContent = displayText;
            }

            updateCartNote();

        }, 100);
    }

    
    // selection input radio
    function getSelectedDeliveryOption() {
        const selectedRadio = document.querySelector(
            'input[name="delivery_option_radio"]:checked'
        );

        if (selectedRadio) {
            return selectedRadio.value;
        }

        return null;
    }


    // Masque les heures déjà passées si la date choisie est aujourd'hui (format jj-mm-aaaa)
    function filterHeuresPassees(selectedDate) {
        var select = document.getElementById('heure_retrait');
        if (!select) return;

        Array.from(select.options).forEach(function(o) {
            o.disabled = false;
            o.style.display = '';
        });

        var now = new Date();
        var todayStr = String(now.getDate()).padStart(2,'0') + '-'
                     + String(now.getMonth()+1).padStart(2,'0') + '-'
                     + now.getFullYear();

        if (selectedDate !== todayStr) return;

        var h = now.getHours();
        var m = now.getMinutes();

        Array.from(select.options).forEach(function(option) {
            if (!option.value) return;
            var parts = option.value.split(':');
            var oh = parseInt(parts[0], 10);
            var om = parseInt(parts[1], 10);
            if (oh < h || (oh === h && om <= m)) {
                option.disabled = true;
                option.style.display = 'none';
            }
        });
    }

    window.filterHeuresPassees = filterHeuresPassees;



document.addEventListener("DOMContentLoaded", function() {
   
    showLoader();

    var calendarEl = document.getElementById("calendar_delivery");
    if (!calendarEl || typeof FullCalendar === "undefined") {
        hideLoader();
        return;
    }

    createCalendar();

    const deliveryChoices = document.querySelectorAll('.delivery-choix');

    const titre_text_delivery = document.querySelector('.titre-body-text-delivery');
    

    const pickupDates = document.querySelector('.contenue-date--pickup');
    const deliveryDates = document.querySelector('.contenue-date--delivery');

    const block_heure = document.querySelector('.form-chose-heure-retrait');

    const labelCalendrierradio = document.querySelector('.delivery-option-date-type.calendrier-choix label');

    function updateHeureBlockVisibility() {
        majBlocHeure();
    }

    function applyDesQuePossible() {
        const texte = 'Dès que possible';
        document.querySelectorAll('.contenue-date-choces').forEach(s => s.classList.remove('active'));

        if (date_retrait_input) {
            date_retrait_input.value = texte;
            date_retrait_input.removeAttribute('required');
        }
        if (date_estimation_livraison_order) {
            date_estimation_livraison_order.value = texte;
        }
        if (heure_retrait_input) {
            heure_retrait_input.removeAttribute('required');
            heure_retrait_input.value = '';
        }
        const selectHeure = document.getElementById('heure_retrait');
        if (selectHeure) selectHeure.value = '';
        updateHeureBlockVisibility();

        const est_top = document.querySelector('.estimated_complete_top');
        if (est_top) {
            est_top.textContent = moyen_livraison.value == 'Livraison en europe'
                ? 'LIVRAISON ESTIMEE : '
                : 'DATE DE RETRAIT ';
        }
        if (blockdisplayestimat) blockdisplayestimat.textContent = texte;

        document.querySelectorAll('.fc-daygrid-day.active-date').forEach(el => el.classList.remove('active-date'));
        if (evenement_name_attribute) {
            evenement_name_attribute.value = '';
            evenement_name_attribute.required = false;
        }
        const dqp = document.querySelector('.contenue-date-des-que-possible');
        if (dqp) dqp.classList.add('active');
        checkdatavalide();
    }

    window.currentDeliveryMode = 'pickup';
   

    deliveryChoices.forEach(function (choice) {

        choice.addEventListener('click', function (e) {

            e.stopPropagation();
            e.preventDefault();

            showLoader();

            if (this.classList.contains('disabled')) {
                hideLoader();
                return;
            }

            document
                .querySelectorAll('.fc-daygrid-day.active-date')
                .forEach(el => el.classList.remove('active-date'));

            selectionCalendrier = null;
            moyen_livraison.value = ''
            date_retrait_input.value = ''
            heure_retrait_input.value = ''
            if (date_estimation_livraison_order) {
                date_estimation_livraison_order.value = '';
            }
            if (evenement_name_attribute) {
                evenement_name_attribute.value = '';
                evenement_name_attribute.required = false;
            }
            const selectHeure = document.getElementById('heure_retrait');
            if (selectHeure) {
                selectHeure.value = '';
            }
            document.querySelectorAll('.date-pre-dispo.is-active').forEach(el => {
                el.classList.remove('is-active');
            });
            document.querySelectorAll('.date-pre-dispo input[type="radio"]:checked').forEach(r => {
                r.checked = false;
            });
            if (blockdisplayestimat) {
                blockdisplayestimat.textContent = '-- sélectionnez une date --';
            }

            deliveryChoices.forEach(function (item) {
                item.classList.remove('active');
            });

            this.classList.add('active');

            const radio = this.querySelector('input[type="radio"]');

            const titre_ration_head_event = document.querySelectorAll('.titre_ration_head_event');

            if (radio) {

                // On fixe le mode AVANT de déclencher l'événement change
                window.currentDeliveryMode = radio.value === 'pickup' ? 'pickup' : 'delivery';

                radio.checked = true;
                radio.dispatchEvent(new Event('change', { bubbles: true }));

                // Changer le texte selon la valeur
                if (radio.value === 'pickup') {

                    // addProduitFantone(57196670321027,57196671959427)

                    titre_text_delivery.textContent = 'QUAND SOUHAITEZ-VOUS RECUPERER VOTRE COMMANDE ?';

                    if (labelCalendrierradio) {
                        labelCalendrierradio.textContent = 'Choisir une date de retrait';
                    }

                    titre_ration_head_event.forEach(el => {
                        el.textContent = 'Retrait pour ';
                    });

                    if (pickupDates) pickupDates.classList.add('is-active');
                    if (deliveryDates) deliveryDates.classList.remove('is-active');

                    if(information_header){
                        information_header.classList.remove('d-none');
                    }

                    if(adresse_tatapaulette){
                        adresse_tatapaulette.classList.remove('d-none');
                    }

                    if(moyen_livraison){
                        moyen_livraison.value = 'Retrait en boutique';
                    }

                    if(heure_retrait_input){
                        heure_retrait_input.required = true;
                    }

                    if(date_estimation_livraison_order){
                        date_estimation_livraison_order.removeAttribute('required');
                    }

                    window.currentDeliveryMode = 'pickup';
                    updateHeureBlockVisibility();

                } else {

                    // addProduitFantone(57196671959427,57196670321027)

                    titre_text_delivery.textContent = 'QUAND SOUHAITEZ-VOUS RECEVOIR VOTRE COMMANDE ? ';

                    if (deliveryDates) deliveryDates.classList.add('is-active');
                    if (pickupDates) pickupDates.classList.remove('is-active');

                    if (labelCalendrierradio) {
                        labelCalendrierradio.textContent = 'Choisir une date de livraison';
                    }

                    titre_ration_head_event.forEach(el => {
                        el.textContent = 'Livraison pour ';
                    });

                    if(information_header){
                        information_header.classList.add('d-none');
                    }

                    if(adresse_tatapaulette){
                        adresse_tatapaulette.classList.add('d-none');
                    }
                    

                    if(moyen_livraison){
                        moyen_livraison.value = 'Livraison en europe';
                    }

                    if(heure_retrait_input){
                        heure_retrait_input.removeAttribute('required');
                    }

                    if(date_estimation_livraison_order){
                        date_estimation_livraison_order.required = true;
                    }

                    window.currentDeliveryMode = 'delivery';
                    updateHeureBlockVisibility();

                }

                if (getSelectedDeliveryOption() === 'des_possible') {
                    applyDesQuePossible();
                } else {
                    checkdatavalide();
                }

                majLegendeEvenement();
                updateCalendarAppearance();
                allerPremiereDateEvenement();

                updateCartNote();

            } 


            setTimeout(() => {
                hideLoader();
            }, 300);


        });

    });



    // gerer le click sur section des que possible 

    const dateRadios = document.querySelectorAll('.date-pre-dispo input[type="radio"]');

    dateRadios.forEach(radio => {

        radio.addEventListener('change', function () {

            // Supprimer la classe active partout
            document.querySelectorAll('.date-pre-dispo').forEach(item => {
                item.classList.remove('is-active');
            });

            // Ajouter la classe active sur le parent label
            this.closest('.date-pre-dispo').classList.add('is-active');

            // Récupérer la value sélectionnée
            const selectedValuedqpossible = this.value;

            if(date_retrait_input) {
                date_retrait_input.value = selectedValuedqpossible;
            }

            checkdatavalide();
            showDateestimation();
            filterHeuresPassees(selectedValuedqpossible);

        });

    });


    if (heureSelect) {
        
        heureSelect.addEventListener('change', function() {
            const selectedHour = this.value;

            if (heure_retrait_input) {
                heure_retrait_input.value = selectedHour;
            }

            showDateestimation();
            checkdatavalide();

        });
        
    }


    document.addEventListener('change', function (e) {
        if (e.target.name !== 'delivery_option_radio') return;

        const section_choice = document.querySelectorAll('.contenue-date-choces');
        const date_calendrier_choice = document.querySelector('.contenue-chose-calendar-date');
        const selectedValue = getSelectedDeliveryOption();

        section_choice.forEach(section => {
            section.classList.remove('active');
        });

        if (selectedValue == 'des_possible') {

            applyDesQuePossible();

        } else if (selectedValue == 'date_specifique') {

            selectionCalendrier = null;
            date_retrait_input.value = '';
            date_retrait_input.setAttribute('required', 'required');
            if (heure_retrait_input) {
                heure_retrait_input.setAttribute('required', 'required');
                heure_retrait_input.value = '';
            }
            const selectHeureDS = document.getElementById('heure_retrait');
            if (selectHeureDS) {
                selectHeureDS.value = '';
            }
            updateHeureBlockVisibility();

            if (date_calendrier_choice) date_calendrier_choice.classList.add('active');
            appliquerEvenement(null);
            checkdatavalide();

        } else {

            // Événement : on garde le calendrier et on y surligne les dates de l'événement
            if (date_calendrier_choice) date_calendrier_choice.classList.add('active');
            selectionnerEvenement(e.target.dataset.name);

        }

    });


    btn_to_proced.addEventListener('click', function (e) {

        if (this.classList.contains('not-passed')) {
            const selectedDeliveryOption = getSelectedDeliveryOption();
            const isDesQuePossible = selectedDeliveryOption === 'des_possible';

            // Si "Dès que possible" est sélectionné, autoriser le checkout
            if (isDesQuePossible) {
                return; // Ne pas bloquer, laisser le formulaire se soumettre
            }

            let message = window.currentDeliveryMode === 'pickup'
                ? 'Veuillez choisir une date et heure valide ici'
                : 'Veuillez choisir une date ici';

            alert_body_text_delivery.textContent = message;

            // Le masquer après 5 secondes
            setTimeout(() => {
                alert_body_text_delivery.textContent = '';
            }, 5000);

            e.stopPropagation();
            e.preventDefault();

            return;

        }

    });


    // Si le panier a mémorisé "livraison", on applique ce mode au chargement
    const choixActif = document.querySelector('.delivery-choix.active');
    if (choixActif && choixActif.querySelector('input[value="delivery_europe"]')) {
        choixActif.click();
    }


    setTimeout(() => {
        hideLoader();
    }, 3000);


});

// Toast « Produit ajouté au panier » (haut-centré)
(function () {

    const TOAST_DURATION = 6000;
    let toastTimer = null;

    function hideToast(toast) {

        if (toastTimer) clearTimeout(toastTimer);
        toastTimer = null;

        toast.classList.add('cart-toast--hidden');

        setTimeout(() => {
            toast.remove();
        }, 300);

    }

    function getProductTitle(productId) {

        if (!productId) return '';

        const form = document.querySelector(`product-form-component[data-product-id="${productId}"]`);
        if (!form) return '';

        const quickAdd = form.closest('quick-add-component');
        if (quickAdd && quickAdd.dataset.productTitle) {
            return quickAdd.dataset.productTitle;
        }

        const modal = form.closest('.quick-add-modal__content');
        const modalTitle = modal && modal.querySelector('.view-product-title a');
        if (modalTitle) return modalTitle.textContent.trim();

        const section = form.closest('section');
        const pageTitle = section && section.querySelector('.view-product-title a');
        if (pageTitle) return pageTitle.textContent.trim();

        return '';

    }

    function showToast(productTitle) {

        const existing = document.querySelector('.cart-toast');
        if (existing) existing.remove();

        if (toastTimer) clearTimeout(toastTimer);
        toastTimer = null;

        const toast = document.createElement('div');
        toast.className = 'cart-toast';

        const message = document.createElement('span');
        message.className = 'cart-toast__message';
        message.textContent = 'Produit ajouté au panier';

        toast.appendChild(message);

        if (productTitle) {
            const product = document.createElement('span');
            product.className = 'cart-toast__product';
            product.textContent = productTitle;
            toast.appendChild(product);
        }

        document.body.appendChild(toast);

        toastTimer = setTimeout(() => {
            hideToast(toast);
        }, TOAST_DURATION);

    }

    document.addEventListener('cart:update', (event) => {

        const data = event.detail?.data;
        if (!data || data.didError) return;
        if (data.source !== 'product-form-component') return;

        showToast(getProductTitle(data.productId));

    });

})();


if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || 
    navigator.userAgent.toUpperCase().indexOf('MAC') >= 0) {
  document.documentElement.classList.add('mac');
}